import React, { useEffect } from 'react';
import "./funciones.css";
import { funciones } from '../../json/funciones';

const Funciones = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container container-mh'>
            <div className='row'>
                <div className='col-12'>
                    <h2>Funciones</h2>
                    <ul className='funciones'>
                        {funciones.map((item, index) => (
                            <li key={index}>{item.funcion}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Funciones